import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';


export class CalendarAllDayEventComponent {

   event: CalendarEvent;

   customTemplate: TemplateRef<any>;

   eventClicked: EventEmitter<any> = new EventEmitter();

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-calendar-all-day-event',
  template: `
    <ng-template #defaultTemplate>
      <div
        class="cal-all-day-event"
        [style.backgroundColor]="event.color.secondary"
        [style.borderColor]="event.color.primary">
        <mwl-calendar-event-title
          [event]="event"
          view="day"
          (click)="eventClicked.emit()">
        </mwl-calendar-event-title>
        <mwl-calendar-event-actions [event]="event"></mwl-calendar-event-actions>
      </div>
    </ng-template>
    <ng-template
      [ngTemplateOutlet]="customTemplate || defaultTemplate"
      [ngTemplateOutletContext]="{
        event: event,
        eventClicked: eventClicked
      }">
    </ng-template>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'event': [{ type: Input },],
'customTemplate': [{ type: Input },],
'eventClicked': [{ type: Output },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
